export default __webpack_public_path__ + "static/media/wellbeing-green.50c05888.svg";